import { Component, OnInit, Inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Ordered } from 'src/app/models/ordered';
import { SnackBarIconService } from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import { OrderedService } from 'src/app/services/ordered.service';
import { FormGroup, FormControl, FormBuilder, FormGroupDirective, NgForm } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/compat/firestore';
/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-transfer-dialog',
  templateUrl: './transfer-dialog.component.html',
  styleUrls: ['./transfer-dialog.component.scss']
})
export class TransferDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public ordered: Ordered = new Ordered()

  public entityForm: FormGroup;

  public spinner: boolean;

  constructor(
    private _adapter: DateAdapter<any>,
    private db: AngularFirestore,
    private fb: FormBuilder,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    public _orderedService: OrderedService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.ordered = this.data;
  }

  ngOnInit() {

    this._adapter.setLocale('pt');
    this.entityForm = this.createForm()
    this.setFormValues(this.ordered, this.entityForm)


  }

  createForm() {

    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      payment_date: new FormControl('')
    });

    return form
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    if (data.payment_date && data.payment_type == 'transfer' && data.returnCode == "00") {
      let dt: any = data.payment_date
      form.controls.payment_date.setValue(new Date(dt.seconds * 1000));
    }
  }

  updateOrder() {
    this._orderedService.spinner = true;

    const tid = 'tr' + new Date().getTime()
    //console.log(tid)
    this._orderedService.updateOrder(this.ordered.id, {
      'id': this.entityForm.controls.id.value,
      'Tid': tid,
      'payment_date': this.entityForm.controls.payment_date.value,
      'returnCode': "00"
    })
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success')
        this.dialog.closeAll()
      })
      .catch((error) => {
        console.log("error insert ordered")
        this.snackBar.openSnackBar("Erro!", '', 'error')
      })
      .finally(() => {
        this._orderedService.spinner = false;
      })

  }

}



